import { sortLayersByOrder } from "../../configuration/utils.js";
const rapid420 = ( values, currentArea ) => {
  const layers = [];

  if(currentArea === "POTENCIA_SECCION"){
    layers.push({ folder: "POTENCIA", imageName: "FONDO" })
    layers.push({ folder: "POTENCIA", imageName: values.EV_POTENCIA })
    if(values.EV_TIPO_REFRIGERACION === "LIQUIDO"){
      layers.push({ folder: "POTENCIA", imageName: "REFRIGERACION" })
    }
  }else{
    // BODY
    layers.push({ folder: "BODY", imageName: values.EV_NUM_CONECTORES });
    
    if(values.EV_NUM_CONECTORES !== "420_ONE"){
      // VATÍMETROS -> En el One no se enseña el izquierdo
      layers.push({ folder: "OTHERS", imageName: "VAT_LEFT" });
    }

    layers.push({ folder: "OTHERS", imageName: "VAT_RIGHT" });
    
    // ANTENAS -> Se muestran siempre indiferentemente de la configuración seleccionada
    layers.push({ folder: "OTHERS", imageName: "ANTENA_INF" });
    layers.push({ folder: "OTHERS", imageName: "ANTENA_MID" });
    layers.push({ folder: "OTHERS", imageName: "ANTENA_SUP" });

    // LEFT FRONT
    if (values.EV_TIPO_CONECTOR_LEFT_FRONT) {
      layers.push({
        folder: "LEFT_FRONT",
        imageName: values.EV_LONGITUD_MANGUERA_FRONT + "_" + values.EV_TIPO_CONECTOR_LEFT_FRONT,
      });
    }

    // RIGHT FRONT
    if (values.EV_TIPO_CONECTOR_RIGHT_FRONT) {
      layers.push({
        folder: "RIGHT_FRONT",
        imageName: values.EV_LONGITUD_MANGUERA_FRONT + "_" + values.EV_TIPO_CONECTOR_RIGHT_FRONT,
      });
    }

    // LEFT SIDE
    if (values.EV_TIPO_CONECTOR_LEFT_SIDE) {
      layers.push({
        folder: "LEFT_SIDE",
        imageName: values.EV_LONGITUD_MANGUERA_SIDE + "_" + values.EV_TIPO_CONECTOR_LEFT_SIDE,
      });
    }

    // RIGHT SIDE
    if (values.EV_TIPO_CONECTOR_RIGHT_SIDE) {
      layers.push({
        folder: "RIGHT_SIDE",
        imageName: values.EV_LONGITUD_MANGUERA_SIDE + "_" + values.EV_TIPO_CONECTOR_RIGHT_SIDE,
      });
    }

    // OTHERS
    if (values.EV_CONTACTLESS) {
      layers.push({
        folder: "OTHERS",
        imageName: "CONTACTLESS",
      });
    }

    if (values.EV_PULSADOR_EMERGENCIA === true) {
      layers.push({
        folder: "OTHERS",
        imageName: "PULSADOR_EMERGENCIA",
      });
    }
  }

  // ORDEN PERSONALIZADO
  const layerOrder = [
    "BODY",
    "OTHERS:PULSADOR_EMERGENCIA",
    "OTHERS:CONTACTLESS",
    "RIGHT_FRONT",
    "LEFT_FRONT",
    "LEFT_SIDE",
    "RIGHT_SIDE",
  ];

  return sortLayersByOrder(layers, layerOrder);
};

export default rapid420;
